export function billPayerSplitConfigurationTypePatcher(data) {
    return {
        __typename: 'UpdateBillPayerSplitConfiguration',
        billPayerShares: data.billPayerShares.map(share => ({
            __typename: 'BillPayerShare',
            ...share,
        })),
    };
}
